import { Pipe, PipeTransform } from '@angular/core';
import { FilterMatchMode } from 'primeng/api';

@Pipe({ standalone: false,
  name: 'mxTableColoredRow',
})
export class MxTableColoredRowPipe implements PipeTransform {
  constructor() {}
  private color: string;
  transform(
    rowData: any,
    tableColoredRows: {
      field: string;
      matchMode: FilterMatchMode;
      value: any;
      color: string;
    }[]
  ): string {
    if (tableColoredRows) {
      tableColoredRows.forEach((coloredRow) => {
        const currentRowDataField = rowData[coloredRow.field];
        if (currentRowDataField === coloredRow.value) {
          this.color = coloredRow.color;
        }
      });
    }

    return this.color;
  }
}
